module.exports = __webpack_public_path__ + "img/dashboard.1a7f07a9.png";